export const dhangadhi = {
    title: "धनगढी",
    title_en: "dhangadhi",
    municipality: "उपमहानगरपालिका",
    municipality_en: "Sub-Metropolitan City",
    municipality_title_en: "Dhangadhi Sub-Metropolitan City",
    municipality_title: "धनगढी उप-महानगरपालिका",
    basicMap: false,
    apkUrl: "https://play.google.com/store/apps/details?id=com.yipl.infrastructuremonitoring",
    isSegregated: false,
    contact_en: {
        region: "Dhangadhi",
        location: "Kailali, Sudurpashchim Province, Nepal",
        phn_no: "+977-91-525506 ",
        email1: "dhangadhimun2013@gmail.com",
        email2: "info@dhangadhimun.gov.np",
    },
    contact_np: {
        region: "धनगढी",
        location: "कैलाली, सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "+९७७-९१-५२५५०६ ",
        email1: "dhangadhimun2013@gmail.com",
        email2: "info@dhangadhimun.gov.np",
    },
}

export const dhangadhi_plus = {
    title: "धनगढी",
    title_en: "dhangadhi_plus",
    municipality: "उपमहानगरपालिका",
    municipality_en: "Sub-Metropolitan City",
    municipality_title_en: "Dhangadhi Sub-Metropolitan City",
    municipality_title: "धनगढी उप-महानगरपालिका",
    basicMap: false,
    apkUrl: "https://play.google.com/store/apps/details?id=com.yipl.infrastructuremonitoring",
    isSegregated: false,
    contact_en: {
        region: "Dhangadhi",
        location: "Kailali, Sudurpashchim Province, Nepal",
        phn_no: "+977-91-525506 ",
        email1: "dhangadhimun2013@gmail.com",
        email2: "info@dhangadhimun.gov.np",
    },
    contact_np: {
        region: "धनगढी",
        location: "कैलाली, सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "+९७७-९१-५२५५०६ ",
        email1: "dhangadhimun2013@gmail.com",
        email2: "info@dhangadhimun.gov.np",
    },
}

export const kailari = {
    title: "कैलारी",
    title_en: "kailari",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Kailari Rural Municipality",
    municipality_title: "कैलारी गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Kailari",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "9858420737 ",
        email1: "vdc.hasuliya@gmail.com",
        email2: "kailarigaupalika@gmail.com",
    },
    contact_np: {
        region: "कैलारी",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "९८५८४२०७३७",
        email1: "vdc.hasuliya@gmail.com",
        email2: "kailarigaupalika@gmail.com",
    },
}

export const godawari = {
    title: "गाेदावरी",
    title_en: "godawari",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Godawari Municipality",
    municipality_title: "गाेदावरी नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Godawari",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "+977 091 551305",
        email1: "mungodawari@gmail.com ",
        email2: "info@godawarimunkailali.gov.np",
    },
    contact_np: {
        region: "गाेदावरी",
        location: "प्रदेश न. ७ नेपाल",
        phn_no: "+९७७ ०९१ ५५१३०५",
        email1: "mungodawari@gmail.com ",
        email2: "info@godawarimunkailali.gov.np",
    },
}

export const amargadhi = {
    title: "अमरगढी",
    title_en: "amargadhi",
    municipality: "नगरपालिका",
    municipality_en: " Municipality",
    municipality_title_en: "Amargadhi Municipality",
    municipality_title: "अमरगढी नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Amargadhi",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "+977-096-410022 ",
        email1: "ito.amargadhimun@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "अमरगढी",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "०९६-४१००२२",
        email1: "ito.amargadhimun@gmail.com",
        email2: "",
    },
}

export const nawadurga = {
    title: "नवदुर्गा",
    title_en: "nawadurga",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Nawadurga Rural Municipality",
    municipality_title: "नवदुर्गा गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    contact_en: {
        region: "Nawadurga",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "",
        email1: "",
        email2: "",
    },
    contact_np: {
        region: "नवदुर्गा",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "",
        email1: "",
        email2: "",
    },
}

export const kathmandu = {
    title: "काठमाण्डौ",
    title_en: "kathmandu",
    municipality: "महानगरपालिका",
    municipality_en: "Metropolitan City",
    municipality_title_en: "Kathmandu Metropolitan City",
    municipality_title: "काठमाडौँ महानगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Kathmandu",
        location: "3 No. Province, Nepal",
        phn_no: "+977-98000000",
        email1: "mayor@kathmandu.gov.np",
        email2: "kmcmayor@mos.com.np",
    },
    contact_np: {
        region: "काठमाण्डौ",
        location: "३ नं प्रदेश, नेपाल",
        phn_no: "+९७७ १४२३१४८१",
        email1: "mayor@kathmandu.gov.np",
        email2: "kmcmayor@mos.com.np",
    },
}

export const kirtipur = {
    title: "कीर्तिपुर",
    title_en: "kirtipur",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Kirtipur Municipality",
    municipality_title: "कीर्तिपुर नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Kirtipur",
        location: "3 No. Province, Nepal",
        phn_no: "+977-01-4331693",
        email1: "ict.munkirtipur@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "कीर्तिपुर",
        location: "३ नं प्रदेश, नेपाल",
        phn_no: "+९७७ ०१-४३३१६९३",
        email1: "ict.munkirtipur@gmail.com",
        email2: "",
    },
}

export const barhabise = {
    title: "कीर्तिपुर",
    title_en: "barhabise",
    municipality: "बाह्रविसे",
    municipality_en: "Municipality",
    municipality_title_en: "Barhabise Municipality",
    municipality_title: "बाह्रविसे नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Barhabise",
        location: "3 No. Province, Nepal",
        phn_no: "+977-01-1489003",
        email1: "barhabisemun@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "बाह्रविसे",
        location: "३ नं प्रदेश, नेपाल",
        phn_no: "+९७७ ०१-१४८९०००३",
        email1: "barhabisemun@gmail.com",
        email2: "",
    },
}

export const konjyosom = {
    title: "कोन्ज्योसोम",
    title_en: "konjyosom",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Konjyosom Rural Municipality",
    municipality_title: "कोन्ज्योसोम गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Lalitpur",
        location: "3 No. Province, Nepal",
        phn_no: "",
        email1: "konjyosom2075@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "ललितपुर",
        location: "३ नं प्रदेश, नेपाल",
        phn_no: "",
        email1: "konjyosom2075@gmail.com",
        email2: "",
    },
}

export const sanfebagar = {
    title: "साँफेबगर",
    title_en: "sanfebagar",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Sanfebagar Municipality",
    municipality_title: "साँफेबगर नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Aachham",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "",
        email1: "",
        email2: "",
    },
    contact_np: {
        region: "अछाम",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "",
        email1: "",
        email2: "",
    },
}

export const mahalaxmi = {
    title: "महालक्ष्मी",
    title_en: "mahalaxmi",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Mahalaxmi Municipality",
    municipality_title: "महालक्ष्मी नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Lalitpur",
        location: "3 No. Province, Nepal",
        phn_no: "01-5203592, 01-5201633, 01-5201733",
        email1: "info@mahalaxmimun.gov.np",
        email2: "",
    },
    contact_np: {
        region: "ललितपुर",
        location: "३ नं प्रदेश, नेपाल",
        phn_no: "०१–५२०३५९२, ०१–५२०१६३३, ०१–५२०१७३३",
        email1: "info@mahalaxmimun.gov.np",
        email2: "",
    },
}

export const melamchi = {
    title: "मेलम्ची",
    title_en: "melamchi",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Melamchi Municipality",
    municipality_title: "मेलम्ची नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Sindhupalchowk",
        location: "Sindhupalchowk",
        phn_no: "+977-011-401089",
        email1: "dms.melamchimun@gmail.com",
        email2: "ito.melamchimun@gmail.com",
    },
    contact_np: {
        region: "सिन्धुपाल्चोक",
        location: "सिन्धुपाल्चोक",
        phn_no: "+९७७ ०११–४०१०८९ ०११–४०११४१ ०११–४०११४२",
        email1: "dms.melamchimun@gmail.com",
        email2: "ito.melamchimun@gmail.com",
    },
}

export const mahankal = {
    title: "महाङ्काल",
    title_en: "mahankal",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Mahankal Rural Municipality",
    municipality_title: "महाङ्काल गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Lalitpur",
        location: "Lalitpur",
        phn_no: "+977-9851199114",
        email1: "mahankalmun2017@gmail.com",
        email2: "ito.mahankalmun@gmail.com",
    },
    contact_np: {
        region: "ललितपुर",
        location: "ललितपुर",
        phn_no: "+९७७ ९८५११९९११४",
        email1: "mahankalmun2017@gmail.com",
        email2: "ito.mahankalmun@gmail.com",
    },
}

export const jayaprithvi = {
    title: "जयपृथ्वी",
    title_en: "jayaprithvi",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Jayaprithvi Municipality",
    municipality_title: "जयपृथ्वी नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Sudurpashchim Province",
        location: "Chainpur, Bajhang",
        phn_no: "+977-092-421064",
        email1: "jpmunicipality2014@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "सुदूरपश्चिम प्रदेश",
        location: "चैनपुर, बझाङ",
        phn_no: "+९७७-०९२-४२१०६४",
        email1: "jpmunicipality2014@gmail.com",
        email2: "",
    },
}

export const masta = {
    title: "मष्टा",
    title_en: "masta",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Masta Rural Municipality",
    municipality_title: "मष्टा गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Sudurpashchim Province",
        location: "Bajhang",
        phn_no: "+977-9868729557",
        email1: "ito.mastamun@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "सुदूरपश्चिम प्रदेश",
        location: "बझाङ",
        phn_no: "+९७७-९८६८७२९५५७",
        email1: "ito.mastamun@gmail.com",
        email2: "",
    },
}

export const bannigadhijayagadh = {
    title: "बान्नीगढ़ी जयगढ़",
    title_en: "bannigadhijayagadh",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Bannigadhi Jayagadh Rural Municipality",
    municipality_title: "बान्नीगढ़ी जयगढ़ गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Aachham",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "9848435423",
        email1: "info@bannigadhijaygadhmun.gov.np",
        email2: "",
    },
    contact_np: {
        region: "अछाम",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "९८४८४३५४२३",
        email1: "info@bannigadhijaygadhmun.gov.np",
        email2: "",
    },
}

export const mellekh = {
    title: "मेल्लेख",
    title_en: "mellekh",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Mellekh Rural Municipality",
    municipality_title: "मेल्लेख गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: true,
    contact_en: {
        region: "Aachham",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "9858482122",
        toll_free: "18105000019",
        email1: "info@mellekhmun.gov.np",
        email2: "mellekhgaupalika@gmail.com",
        website: "http://www.mellekhmun.gov.np"
    },
    contact_np: {
        region: "अछाम",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "9858482122",
        toll_free: "18105000019",
        email1: "info@mellekhmun.gov.np",
        email2: "mellekhgaupalika@gmail.com",
        website: "http://www.mellekhmun.gov.np"
    },
}

export const chaurpati = {
    title: "चौरपाटी",
    title_en: "chaurpati",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Chaurpati Rural Municipality",
    municipality_title: "चौरपाटी गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Aachham",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "9749650949",
        email1: "chaurpatigaupalika@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "अछाम",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "९७४९६५०९४९",
        email1: "chaurpatigaupalika@gmail.com",
        email2: "",
    },
}

export const durgathali = {
    title: "दुर्गाथली",
    title_en: "durgathali",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Durgathali Rural Municipality",
    municipality_title: "दुर्गाथली गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Bajhang",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "9858485620",
        email1: "durgathalimun23@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "बझाङ्ग",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "9858485620",
        email1: "durgathalimun23@gmail.com",
        email2: "",
    },
}

export const khaptadchanna = {
    title: "खप्तडछान्ना",
    title_en: "khaptadchanna",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Khaptadchanna Rural Municipality",
    municipality_title: "खप्तडछान्ना गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Bajhang",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "9858485616",
        email1: "",
        email2: "",
        website: "https://khaptadchhannamun.gov.np/",
    },
    contact_np: {
        region: "बझाङ्ग",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "9858485616",
        email1: "",
        email2: "",
        website: "https://khaptadchhannamun.gov.np/",
    },
}

export const bagmati = {
    title: "वाग्मती",
    title_en: "bagmati",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Bagmati Rural Municipality",
    municipality_title: "वाग्मती गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Lalitpur",
        location: "Bagmati Province, Nepal",
        phn_no: "9851255900",
        email1: "bagmatigaupalika@gmail.com ",
        email2: "",
    },
    contact_np: {
        region: "ललितपुर",
        location: "वाग्मती प्रदेश, नेपाल",
        phn_no: "9851255900",
        email1: "bagmatigaupalika@gmail.com ",
        email2: "",
    },
}

export const parashuram = {
    title: "परशुराम",
    title_en: "parashuram",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Parashuram Municipality",
    municipality_title: "परशुराम नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Dadeldhura",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "+977-096-411004",
        email1: "parshurammun@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "डडेल्धुरा",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "०९६-४११००४",
        email1: "parshurammun@gmail.com",
        email2: "",
    },
}

export const nalgaad = {
    title: "नलगाड",
    title_en: "nalgaad",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Nalgaad Municipality",
    municipality_title: "नलगाड नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    contact_en: {
        region: "Dalli, Jajarkot",
        location: "Karnali Province, Nepal",
        phn_no: "+9758003500",
        email1: "ito.nalgaadmun@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "दल्ली, जाजरकाेट",
        location: "कर्णाली प्रदेश, नेपाल",
        phn_no: "०९६-४११००४",
        email1: "ito.nalgaadmun@gmail.com",
        email2: "",
    },
}

export const gauriganga = {
    title: "गौरीगङ्गा",
    title_en: "gauriganga",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Gauriganga Municipality",
    municipality_title: "गौरीगङ्गा नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Kailali",
        location: "Sudurpashchim Province, Nepal",
        phn_no: "+977-091-418060",
        email1: "info.gaurigangamun@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "कैलाली",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "०९१-४१८०६०",
        email1: "info.gaurigangamun@gmail.com",
        email2: "",
    },
}

export const demo = {
    title: "नमुना",
    title_en: "demo",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Demo Municipality",
    municipality_title: "नमूना नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Sample region",
        location: "Sample location",
        phn_no: "+977-98000000",
        email1: "sample@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "नमुना",
        location: "नमूना स्थान",
        phn_no: "+९७७ १४२३१४८१",
        email1: "sample@gmail.com",
        email2: "",
    },
}

export const annapurna_kaski = {
    title: "अन्नपूर्ण",
    title_en: "annapurna_kaski",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Annapurna Rural Municipality",
    municipality_title: "अन्नपूर्ण गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Kaski",
        location: "Gandaki Province, Nepal",
        phn_no: "061414101",
        email1: "apgaupalika@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "कास्की",
        location: "गण्डकी प्रदेश, नेपाल",
        phn_no: "061414101",
        email1: "apgaupalika@gmail.com",
        email2: "",
    },
}

export const mangalsen = {
    title: "मंगलसेन",
    title_en: "mangalsen",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Mangalsen Municipality",
    municipality_title: "मंगलसेन नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Achham",
        location: "Far-Western Province, Nepal",
        phn_no: "097-620138",
        email1: "mmunicipalityachham@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "अछाम",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "097-620138",
        email1: "mmunicipalityachham@gmail.com",
        email2: "",
    },
}

export const bheri = {
    title: "भेरी",
    title_en: "bheri",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "Bheri Municipality",
    municipality_title: "भेरी नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Karnali",
        location: "Karnali Province, Nepal",
        phn_no: "089-430002",
        email1: "bherimun@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "कर्णाली",
        location: "कर्णाली प्रदेश, नेपाल",
        phn_no: "089-430002",
        email1: "bherimun@gmail.com",
        email2: "",
    },
}

export const chure = {
    title: "चुरे",
    title_en: "chure",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Chure Rural Municipality",
    municipality_title: "चुरे गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Kailali",
        location: "Far-Western Province, Nepal",
        phn_no: "9848460012",
        email1: "chure.gaupalika@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "कैलाली",
        location: "सुदूरपश्चिम प्रदेश, नेपाल",
        phn_no: "9848460012",
        email1: "chure.gaupalika@gmail.com",
        email2: "",
    },
}

export const yipl = {
    title: "योङ्ग इनोभेसन्स",
    title_en: "yipl",
    municipality: "नगरपालिका",
    municipality_en: "Municipality",
    municipality_title_en: "YIPL Municipality",
    municipality_title: "योङ्ग इनोभेसन्स नगरपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Kathmandu",
        location: "3 No. Province, Nepal",
        phn_no: "+977-1-5536093",
        email1: "info@yipl.com.np",
    },
    contact_np: {
        region: "काठमाण्डौ",
        location: "३ नं प्रदेश, नेपाल",
        phn_no: "+९७७-१-५५३६०९३",
        email1: "info@yipl.com.np",
    },
}

export const aandhikhola = {
    title: "आँधिखोला",
    title_en: "aandhikhola",
    municipality: "गाउँपालिका",
    municipality_en: "Rural Municipality",
    municipality_title_en: "Aandhikhola Rural Municipality",
    municipality_title: "आँधिखोला गाउँपालिका",
    basicMap: false,
    apkUrl: "#",
    isSegregated: false,
    contact_en: {
        region: "Syangja",
        location: "Gandaki Province, Nepal",
        phn_no: "9846005608",
        email1: "andhikholarm@gmail.com",
        email2: "",
    },
    contact_np: {
        region: "स्याङ्जा",
        location: "गण्डकी प्रदेश, नेपाल",
        phn_no: "9846005608",
        email1: "andhikholarm@gmail.com",
        email2: "",
    },
}



// WEBPACK FOOTER //
// ./src/config/municipalities.js